export const SUPPORT_TICKET_TYPE_OPTIONS = [
  { value: "addressConfirmation", label: "Address confirmation" },
  { value: "engagement", label: "Engagement" },
  { value: "clinicalSupport", label: "Clinical support" },
  { value: "other", label: "Other" },
  { value: "returnToSender", label: "Return to sender" },
  { value: "returnMerchandiseAuthorization", label: "Return merchandise authorization" },
  { value: "deviceTechnicalSupport", label: "Device technical support" },
  { value: "customerDeviceInquiry", label: "Customer device inquiry" },
  { value: "operations", label: "Operations" },
  { value: "patientSetup", label: "Patient setup" },
  { value: "mobileSupport", label: "Mobile support" },
  { value: "labOrder", label: "Lab order" },
  { value: "alert", label: "Alert" },
  { value: "patientJourney", label: "Patient journey" },
  { value: "generalInquiry", label: "General inquiry" },
  { value: "deviceClaim", label: "Device claim" },
  { value: "technicalSupport", label: "Technical support" },
  { value: "patientEnrollment", label: "Patient enrollment" },
  { value: "patientEngagement", label: "Patient engagement" },
  { value: "accountManagement", label: "Account management" },
  { value: "trackingOrderInquiry", label: "Tracking / order inquiry" },
  { value: "returnReplacementInquiry", label: "Return / replacement inquiry" },
  { value: "procurementSupplyInquiry", label: "Procurement / supply inquiry" },
  { value: "inventoryCheckCountRequest", label: "Inventory check / count request" },
  { value: "platformLoginRequest", label: "Platform login request" },
  { value: "shipmentAddressChangeRequest", label: "Shipment address change request" },
  { value: "apiDatafeedRequest", label: "API / datafeed request" },
  { value: "kitChangeRequest", label: "Kit change request" },
  { value: "howToPlaceOrder", label: "How to place order" },
  { value: "howToReplaceReturnDevice", label: "How to replace / return device" },
  { value: "reportingRequest", label: "Reporting request" },
  { value: "autoAgent", label: "Auto agent" },
] as const;

export function formatSupportTicketType(type: unknown): string {
  const raw = String(type ?? "").trim();
  if (!raw) return "—";
  return raw.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()).trim();
}

export function resolveSupportPatientName(ticket: Record<string, unknown> | null | undefined): string {
  const raw = ticket?.raw as Record<string, unknown> | undefined;
  const patient = (raw?.patient ?? ticket?.patient) as Record<string, unknown> | undefined;
  if (!patient) return "—";
  const name = [patient.firstName, patient.middleName, patient.lastName].filter(Boolean).join(" ").trim();
  return name || "—";
}

export function resolveSupportCreatedByName(ticket: Record<string, unknown> | null | undefined): string {
  const user = (ticket?.createdByUser ?? (ticket?.raw as Record<string, unknown> | undefined)?.createdByUser) as
    | Record<string, unknown>
    | undefined;
  if (!user) return "—";
  const directName = String(user.name ?? "").trim();
  if (directName) return directName;
  const joined = [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
  return joined || "—";
}
